/** Datums-Spalten der Bestellposition — Abschnitt „DateTimes“ aus `IwmColumnsBestellposition`. */

import type { OrderPosition } from '@/types/entities';

import { DateCell } from '../shared/DateCell';
import type { CellTemplateMap } from '../types';
import { OrderPositionRowColor } from './OrderPositionRowColor';

export const orderPositionDateTemplates: CellTemplateMap<OrderPosition> = {
  Belegdatum: (model) => <DateCell value={model.Belegdatum} />,
  LastExported: (model) => <DateCell value={model.LastExported} />,
  Liefertermin: (model) => <DateCell value={model.Liefertermin} />,
  WunschLt: (model) => <DateCell value={model.WunschLt} />,
  OriginalDeliveryDate: (model) => <DateCell value={model.OriginalDeliveryDate} />,
  ConfirmedDeliveryDate: (model) => <DateCell value={model.ConfirmedDeliveryDate} />,
  Psi: (model) => <DateCell value={model.Psi} />,
  ShippingMarksDeadline: (model) => <DateCell value={model.ShippingMarksDeadline} />,
  IdLabelDeadline: (model) => <DateCell value={model.IdLabelDeadline} />,
  ManualDeadline: (model) => <DateCell value={model.ManualDeadline} />,
  PackagingDeadline: (model) => <DateCell value={model.PackagingDeadline} />,
  ShippedDate: (model) => <DateCell value={model.ShippedDate} />,
  PanelDeadline: (model) => <DateCell value={model.PanelDeadline} />,
  BuchdatumAnz: (model) => <DateCell value={model.BuchdatumAnz} />,
  BuchdatumRest1: (model) => <DateCell value={model.BuchdatumRest1} />,
  BuchdatumRest2: (model) => <DateCell value={model.BuchdatumRest2} />,
  SageBuchungDatum: (model) => <DateCell value={model.SageBuchungDatum} />,
  NaechsterTerminLayouts: (model) => <DateCell value={model.NaechsterTerminLayouts} />,
  PlanEta: (model) => <DateCell value={model.PlanEta} />,
  PlanEtd: (model) => <DateCell value={model.PlanEtd} />,
  Container_DepotDatum: (model) => <DateCell value={model.Container_DepotDatum} />,
  Container_DatumZugestellt: (model) => <DateCell value={model.Container_DatumZugestellt} />,
  Container_ETA: (model) => <DateCell value={model.Container_ETA} />,
  Container_ETD: (model) => <DateCell value={model.Container_ETD} />,
  Container_Anlieferdatum: (model) => <DateCell value={model.Container_Anlieferdatum} />,

  // mit Zeilenfarbe
  Container_FruehestAnlieferdatum: (model) => (
    <>
      <OrderPositionRowColor model={model} />
      <DateCell value={model.Container_FruehestAnlieferdatum} />
    </>
  ),
  Container_AnlieferdatumEmpf: (model) => (
    <>
      <OrderPositionRowColor model={model} />
      <DateCell value={model.Container_AnlieferdatumEmpf} />
    </>
  ),
};

export default orderPositionDateTemplates;
